import { userService, USER_ID_KEY } from '../services/userService';

export const XP_PER_CORRECT = 10;

export function awardXp(amount: number = XP_PER_CORRECT): void {
  const userId = localStorage.getItem(USER_ID_KEY);
  if (!userId) return;
  userService.recordTraining(userId, amount).catch(() => {});
}
